import axios from "axios";
import { environment } from "../../environments/environment";
import { PARTNER_DD_URL } from "../../constants/backendUrl";
import { DropdownsResponse } from "../../models/ICommon";

export class CommonService {
  private static URL: any = environment.partnerApiUrl;
  private static QuoteURL: any = environment.quoteApiUrl;

  public static basicinfoDropdown(partnerid: number) {
    let UserURL: string = `${this.URL}/${PARTNER_DD_URL.getBasicInfoDropdownById}/${partnerid}`;
    const config = {
      headers: { Authorization: `Bearer ${sessionStorage.getItem("Token")}` },
    };
    return axios.get<any>(UserURL, config);
  }

  public static getBusinessType() {
    let UserURL: string = `${this.URL}/${PARTNER_DD_URL.getPartnerTransactionType}`;
    const config = {
      headers: { Authorization: `Bearer ${sessionStorage.getItem("Token")}` },
    };
    return axios.get<any>(UserURL, config);
  }

  public static async getAllDropdowns(dropdownIds: number[]): Promise<DropdownsResponse> {
		const endpoint = `${this.URL}/${PARTNER_DD_URL.getCommonDropdown}`;
		const config = {
			headers: { Authorization: `Bearer ${sessionStorage.getItem("Token")}` }
		};
		return axios.post<DropdownsResponse>(endpoint, dropdownIds, config).then((res) => res.data);
	}
public static async refreshAllDropdowns(): Promise<string> {
  const endpoint = `${this.URL}/${PARTNER_DD_URL.updateDropdownCache}`;
  const config = {
    headers: { Authorization: `Bearer ${sessionStorage.getItem("Token")}` }
  };
  return axios.put<string>(endpoint, {}, config).then(res => res.data);
}

public static async refreshAllQuotes(): Promise<string> {
  const endpoint = `${this.QuoteURL}/${PARTNER_DD_URL.updateQuoteCache}`;
  const config = {
    headers: { Authorization: `Bearer ${sessionStorage.getItem("Token")}` }
  };
  return axios.post<string>(endpoint, {}, config).then(res => res.data);
}

}
